/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface CreateAppointmentHourResponse
 */
export interface CreateAppointmentHourResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CreateAppointmentHourResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
}

/**
 * Check if a given object implements the CreateAppointmentHourResponse interface.
 */
export function instanceOfCreateAppointmentHourResponse(value: object): value is CreateAppointmentHourResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateAppointmentHourResponseFromJSON(json: any): CreateAppointmentHourResponse {
    return CreateAppointmentHourResponseFromJSONTyped(json, false);
}

export function CreateAppointmentHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
    };
}

export function CreateAppointmentHourResponseToJSON(json: any): CreateAppointmentHourResponse {
    return CreateAppointmentHourResponseToJSONTyped(json, false);
}

export function CreateAppointmentHourResponseToJSONTyped(value?: CreateAppointmentHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
    };
}

